// extracted by mini-css-extract-plugin
export default {"layout":"_9b92ea1705 _5f9210f1df _99c7bec934","h_slide":"_7774033f22","category":"_7428599dc5 _1ebe4eb2b1 _0d345f2327"};